import axios from '../../../axios';
import CareerBuilderSearch from '../types/CareerBuilderSearch';

export const searchCareerBuilder = async (query: CareerBuilderSearch) =>
  await axios.post('/candidatesearch/api/career-builder/search', query);
